<template>
  <div class="keys-list">
    <div
      class="item"
      v-for="(item, index) in keys"
      :key="index"
      >
      <Item
        :item="item"
        @handleClick="clickItem"
      />
    </div>

    <Picker
      v-if="handleItem.type === 'select'"
      ref="picker"
      v-model="model[handleItem.apiKey]"
      :options="options[handleItem.optionType]"
      :remote-method="
        remoteOptionMethods.includes(handleItem.optionType) ? remoteMethod : null
      "
      :show-add="!!handleItem.apiTextKey && !handleItem.isDict"
      @update="handleChange"
      @add="handleAdd"
    />

    <DateTimePicker
      v-if="handleItem.type === 'date' || handleItem.type === 'datetime'"
      ref="datetimePicker"
      v-model="model[handleItem.apiKey]"
      :type="handleItem.type"
      :start="startTimeLimit()"
      @update="handleChange"
    />

    <NumberPicker
      v-if="handleItem.type === 'number'"
      ref="numberPicker"
      v-model="model[handleItem.apiKey]"
      @update="handleChange"
    />
  </div>
</template>

<script>
import Item from './Item';
import KeysMixin from '@/mixins/keys';
import Picker from '@/components/Picker';
import DateTimePicker from '@/components/DateTimePicker';
import NumberPicker from '@/components/NumberPicker';
import {
  getPackageOptions,
  getUserOptions,
  getDepartmentOptions,
  getEquipments,
  getSterilizeDeadline,
  getPackageDetail,
  getLastPrint
} from '@/api/basic';
import {
  getDicts
} from '@/api/system';

export default {
  name: 'KeyListComponent',
  mixins:[
    KeysMixin
  ],
  components: {
    Item,
    Picker,
    DateTimePicker,
    NumberPicker
  },
  props: {
    renderKeys: {
      type: Array,
      require: true
    }
  },
  watch: {
    renderKeys: {
      deep: true,
      handler() {
        this.makeKeysRendering()
      }
    }
  },
  data() {
    return {
      keys: [],
      model: {},
      options: {
        Department: [],
        Type: [],
        User: [],
        Sterilizer: [],
        Pack: [],
        SterilizeMethod: [],
        Package: []
      },
      handleItem: {}
    }
  },
  methods: {
    clickItem(item) {
      this.handleItem = item
      const {
        apiKey
      } = item
      this.model[apiKey] = this.renderKeys.find(i => i.key === apiKey).value

      this.$nextTick(() => {
        this.triggerPickers()
      })
    },
    triggerPickers() {
      // 触发选择器组件
      const {
        type,
        optionType
      } = this.handleItem
      const {
        picker,
        datetimePicker,
        numberPicker
      } = this.$refs

      switch (type) {
        case 'select':
          this.remoteMethod('', optionType)
          picker && picker.open()
          break;

        case 'date':
          datetimePicker && datetimePicker.open()
          break;

        case 'datetime':
          datetimePicker && datetimePicker.open()
          break;

        case 'number':
          numberPicker && numberPicker.open()
      
        default:
          break;
      }
    },
    startTimeLimit() {
      // 限制开始时间，目前只有灭菌时间需要限制
      const {
        apiKey
      } = this.handleItem
      
      if (apiKey !== 'sterilization_time') {
        return undefined
      }

      const todayStart = this.$moment(new Date()).startOf('day').toDate()

      return todayStart
    },
    remoteMethod(query, optionType = this.handleItem.optionType) {
      switch (optionType) {
        case 'User':
          this.getUserOptions(query)
          break;

        case 'Department':
          this.getDepartmentOptions(query)
          break;

        case 'Package':
          this.getPackageOptions(query)
          break;

        case 'Sterilizer':
          this.getEquipments(2)
      }
    },
    getUserOptions(name) {
      // 人员选项
      const query = {
        name
      }

      getUserOptions(0, query)
      .then(res => {
        if (res) {
          this.options['User'] = res.map(i => Object.assign(i, { value: i.id }))
        }
      })
    },
    getDepartmentOptions(name) {
      // 获取科室选项
      const query = {
        name
      }

      getDepartmentOptions(query)
      .then(res => {
        if (res) {
          this.options['Department'] = res.map(i => Object.assign(i, { value: i.id }))
        }
      })
    },
    getPackageOptions(name) {
      const params = {
        search: name || '',
        type: this.model.instrumentset_type || undefined
      }

      getPackageOptions(params)
      .then((res) => {
        if (res) {
          this.options['Package'] = res.map(i => Object.assign(i, { value: i.id }))
        }
      })
    },
    getEquipments(type) {
      // 获取灭菌器
      getEquipments({ type })
      .then(res => {
        if (res) {
          this.options['Sterilizer'] = res.map(i => Object.assign(i, { value: i.id }))
        }
      })
    },
    handleAdd(query) {
      const {
        apiKey
      } = this.handleItem

      this.updateInlist(apiKey, query, undefined)
    },
    handleChange() {
      // 监听字段变化，统一处理联动相关逻辑
      const {
        apiKey,
        type,
        optionType
      } = this.handleItem
      let value = this.model[apiKey]
      let text = value
      if (type === 'select') {
        var options = this.options[optionType]
        var item = options.filter(i => i.value === value)[0]
        text = item ? item.name : ''
      } else if (type === 'date') {
        text = this.$moment(value).format('yyyy-MM-DD')
        value = this.$moment(value).format('yyyy-MM-DD')
      } else if (type === 'datetime') {
        text = this.$moment(value).format('yyyy-MM-DD HH:mm:ss')
        value = this.$moment(value).format('yyyy-MM-DD HH:mm:ss')
      }
      
      this.updateInlist(apiKey, text, value)
      this.syncSterilizeDeadline(apiKey)
      this.syncPackageDetail(apiKey)
      this.syncSterilizeMethod(apiKey)
      // 如果是选择的灭菌器，那么需要填充灭菌锅次和时间
      if(this.handleItem.apiKey == 'equipment_id'){
        this.$set(this.model,'handle_option',item?.handle_type) // 选择灭菌器的时候，修改灭菌方式的值。（当灭菌器的类型是，select的时候，item有值）
        this.getLastPrintFun()
      }
      // 选择器械包的时候,修改包装材料的值：
      if(this.handleItem.apiKey == "instrumentset_id"){ 
        this.$set(this.model,'pack_option',item?.pack_option) // 选择器械包的时候，修改包装材料的值。（当器械包的类型是，select的时候，item有值）
        let pack_option = this.keys.find(item=>item.apiKey == 'pack_option')
          this.handleItem = pack_option
          this.handleChange()
      }
      // 如果选择的是灭菌锅次，而且此时灭菌锅次有值时需要填充灭菌时间
      if(this.handleItem.apiKey == 'sterilization_pot_frequency' && this.model.equipment_id){
        this.getLastPrintFun2()
      }
    },
    getLastPrintFun(){
      getLastPrint({
        equipment_id:this.model.equipment_id
      }).then(res=>{
        if(res){
          this.$set(this.model, 'sterilization_pot_frequency', res.sterilization_pot_frequency)
          this.$set(this.model, 'sterilization_time', res.sterilization_time)
          let sterilization_pot_frequency = this.keys.find(item=>item.apiKey == 'sterilization_pot_frequency')
          this.handleItem = sterilization_pot_frequency
          this.handleChange()
          let sterilization_time = this.keys.find(item=>item.apiKey == 'sterilization_time')
          this.handleItem = sterilization_time
          this.handleChange()

        }
      })
    },
    getLastPrintFun2(){
      getLastPrint({
        equipment_id:this.model.equipment_id,
        sterilization_pot_frequency:this.model.sterilization_pot_frequency
      }).then(res=>{
        if(res){
          // let sterilization_time = this.keys.find(item=>item.apiKey == 'sterilization_time')
        // this.handleItem = sterilization_time
          // this.$set(this.model, 'sterilization_time', res.sterilization_time)
          // this.handleChange()
          this.updateInlist('sterilization_time', res.sterilization_time,res.sterilization_time)
        }else{
          this.sterilizationTimeForm()
          // let value = this.$moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
          // this.updateInlist('sterilization_time', value,value)
        }
      })
    },
    updateInlist(key, text, value) {
      this.renderKeys.forEach(i => {
        if (i.key === key) {
          const {
            type
          } = i

          if (this.dateTimeTypes.includes(type) && value) {
            const dateArray = value.split(' ')
            if (type === 'date') {
              text = dateArray[0] || ''
            } else if (type === 'time') {
              text = dateArray[1] || ''
            } else if (type === 'datetime') {
              text = value
            }
          }

          this.$set(i, 'text', text)
          this.$set(i, 'value', value)
          if (type === 'list') {
            this.$set(i, 'list', value)
          }
        }
      })

      this.$nextTick(() => {
        this.makeKeysRendering()
        this.$emit('update')
      })
    },
    async syncSterilizeDeadline(apiKey) {
      // 同步灭菌失效日期功能
      const sterilizeDeadlineFactorKeys = [
        'sterilization_time',
        'handle_option',
        'pack_option',
        'instrumentset_id'
      ]

      if (sterilizeDeadlineFactorKeys.includes(apiKey)) {
        const sterilization_expire_time = await this.getSterilizeDeadline()
        if (sterilization_expire_time) {
          this.$set(this.model, 'sterilization_expire_time', sterilization_expire_time)
          this.updateInlist('sterilization_expire_time', sterilization_expire_time, sterilization_expire_time)
        } else {
          this.$set(this.model, 'sterilization_expire_time', undefined)
          this.updateInlist('sterilization_expire_time', '', undefined)
        }
      }
    },
    getSterilizeDeadline() {
      const {
        sterilization_time,
        handle_option,
        pack_option,
        instrumentset_id
      } = this.model

      if (!sterilization_time) {
        return new Promise(r => r(null))
      }

      const query = {
        sterilization_time,
        handle_option,
        pack_option,
        id: instrumentset_id
      }

      return getSterilizeDeadline(query)
      .then(res => {
        return res ? res.deadline_date : null
      })
    },
    async syncPackageDetail(apiKey) {
      // 同步器械明细
      if (apiKey === 'instrumentset_id') {
        const id = this.model.instrumentset_id
        getPackageDetail(id)
        .then(res => {
          if (res) {
            const {
              instrument
            } = res

            const list = instrument.map(i => {
              return {
                name: i.name,
                number: i.number
              }
            })

            this.updateInlist('instruments', '器械明细', list)
          }
        })
      }
    },
    syncSterilizeMethod(apiKey) {
      // 同步灭菌方式
      if (apiKey === 'equipment_id') {
        const sterilizeMethodKeys = this.renderKeys.filter(i => i.key === 'handle_option')
        if (sterilizeMethodKeys.length) {
          const handleType = this.options.Sterilizer.filter(i => i.id === this.model.equipment_id)[0]['handle_type']
          if (!handleType) {
            this.updateInlist('handle_option', '灭菌方式', undefined)
            this.$set(this.model, 'handle_option', undefined)
            return
          }

          const item = this.options.SterilizeMethod.filter(i => i.value === handleType)[0]
          const {
            name,
            value
          } = item

          this.updateInlist('handle_option', name, value)
          this.$set(this.model, 'handle_option', value)
        }
      }
    },
    getDictData() {
      // 获取字典数据
      getDicts([314, 5, 338])
      .then(res => {
        if (res) {
          this.options['Type'] = res[314]
          this.options['Pack'] = res[5]
          this.options['SterilizeMethod'] = res[338]
        }
      })
    },
    makeKeysRendering() {
      this.keys = this.allKeys
      .filter(i => this.renderKeys.map(i => i.key).includes(i.apiKey))
      .filter(i => !this.disabledKeys.includes(i.apiKey))
      .map(i => {
        const item = this.renderKeys.find(j => j.key === i.apiKey)
        this.$set(i, 'text', item.text)
        this.$set(i, 'type', item.type)
        this.$set(this.model,i.apiKey,item.value) // 这里需要对model的值进行绑定，因为有的操作会用到model里的值，如果一开始不对其赋值，后面的无法计算，比如获取灭菌失效时间
        return i
      })
    },
    // 设置灭菌时间为当前时间
    setSterilizationTime(){
      if(this.model.sterilization_time) return; //如果灭菌时间已经有值，比如标签打印历史中的标签，这时候就不用对灭菌时间进行赋值
      this.sterilizationTimeForm()
    },
    sterilizationTimeForm(){
      let keyItem = this.keys.find(item=>item.apiKey == 'sterilization_time')
      if (!keyItem) return;
      const {
        type
      } = keyItem
      let value = undefined
      if (type === 'date') {
        value = this.$moment(new Date()).format('yyyy-MM-DD')
      } else if (type === 'datetime') {
        value = this.$moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
      }
      this.updateInlist('sterilization_time', value,value)
    }
  },
  created() {
    this.getDictData()
    this.makeKeysRendering()
    this.setSterilizationTime()
  }
}
</script>

<style lang="less" scoped>
  .keys-list {
      // gap: 20px;
      .flexgap(20px, row, 3);
      // .flexgap(20px, column);
      flex-wrap: wrap;
      display: flex;
      // justify-content: space-between;
      .flexgap(20px, column);

      .item {
        height: 212px;
        width: calc((100% - 40px) / 3);
      }
    }
</style>